module.exports = __webpack_public_path__ + "static/img/10.9bd7980.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/zh/10.png
// module id = zFz5
// module chunks = 0